<!--
	描述：星迅的svg图的遥控器弹窗
-->
<template>
	<dialogBody class="addDialogBody" @confirm="confirm" @cancel="cancel" :showCance="showCance" ref="body">
		<template slot="title">
			空调遥控参数设定
		</template>
		<div class="flexStart">
			<p>设定温度:</p>
			<input type="number" min="16" max="30" v-model="temperature">
			<p>℃</p>
		</div>
		<div class="flexStart">
			<p>运行模式:</p>
			<label><input name="runTypeRadio" type="radio" :value="0" v-model="runType" /> 关闭 </label>
			<label><input name="runTypeRadio" type="radio" :value="1" v-model="runType" /> 自动 </label>
			<label><input name="runTypeRadio" type="radio" :value="2" v-model="runType" /> 制冷 </label>
			<label><input name="runTypeRadio" type="radio" :value="3" v-model="runType" disabled/> 制热 </label>
			<label><input name="runTypeRadio" type="radio" :value="4" v-model="runType" /> 送风 </label>
			<label><input name="runTypeRadio" type="radio" :value="5" v-model="runType" /> 除湿 </label>
		</div>
		<div class="flexStart">
			<p>设定风速:</p>
			<label><input name="speedRadio" type="radio" :value="0" v-model="speed" /> 自动 </label>
			<label><input name="speedRadio" type="radio" :value="1" v-model="speed" /> 低速 </label>
			<label><input name="speedRadio" type="radio" :value="2" v-model="speed" /> 中速 </label>
			<label><input name="speedRadio" type="radio" :value="3" v-model="speed" /> 高速 </label>
		</div>
		<div class="flexStart">
			<p>垂直风摆:</p>
			<label><input name="verticalRadio" type="radio" :value="0" v-model="vertical" disabled/> 关闭 </label>
			<label><input name="verticalRadio" type="radio" :value="1" v-model="vertical" disabled/> 打开 </label>
		</div>
		<div class="flexStart">
			<p>水平风摆:</p>
			<label><input name="horizontalRadio" type="radio" :value="0" v-model="horizontal" disabled/> 关闭 </label>
			<label><input name="horizontalRadio" type="radio" :value="1" v-model="horizontal" disabled/> 打开 </label>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				temperature:23,
				runType: 0,
				speed: 0,
				vertical: 0,
				horizontal: 0,
				callback: undefined,
				cancelCallBack: undefined,
				prop: [],
				group: undefined,
				operation: undefined,
				timeout: undefined,
				showCance: true
			}
		},
		computed: {},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if (this.callback != undefined) {
					this.callback(this.temperature,this.runType,this.speed,this.horizontal,this.vertical)
				}else{
					//默认执行的内容是调用接口
					this.$api.webSocketApi.airConditionerOperation(this.group,this.operation,this.timeout,this.temperature,this.runType,this.speed,this.horizontal,this.vertical,respon=>{
						this.$dialogMethod.showMessage("下发成功!")
					})
				}
				this.close()
			},
			cancel() {
				if (this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			open(group,operation,timeout,prop, callback, cancelcallback, showCance) {
				this.group = group
				this.operation = operation
				this.timeout = timeout
				this.prop = prop
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.$refs.body.open()
				if (showCance != undefined) {
					this.showCance = showCance
				}
				if (prop != undefined) {
					//初始化
					for (var i = 0, len = prop.length; i < len; i++) {
						var item = prop[i]
						switch (item.appType) {
							case 280:
								//设定温度
								this.temperature = getValueIfNoNull(item.rtValue,23)
								break
							case 281:
								//工作模式
								this.runType = getValueIfNoNull(item.rtValue,0)
								break
							case 282:
								//风速
								this.speed = getValueIfNoNull(item.rtValue,0)
								break
							case 283:
								//垂直风摆
								this.vertical = getValueIfNoNull(item.rtValue,0)
								break
							case 284:
								//水平风摆
								this.horizontal = getValueIfNoNull(item.rtValue,0)
								break
						}
					}
				}
			},
			close() {
				this.$refs.body.hide()
			},
		}
	}
</script>
<style scoped>
	.addDialogBody {
		z-index: 200;
		display: flex;
		align-items: center;
		height: .4rem;
		justify-content: center;
	}

	.addDialogBody>input {
		border: .01rem solid #A9A9A9;
		border-radius: .05rem;
		margin-left: .2rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		width: 2rem;
	}

	.flexStart {
		padding: 10px 0;
	}

	.flexStart label {
		margin-left: 10px;
	}
</style>
